import { render, staticRenderFns } from "./DigitCode.vue?vue&type=template&id=1b3293fb&scoped=true&"
import script from "./DigitCode.vue?vue&type=script&lang=js&"
export * from "./DigitCode.vue?vue&type=script&lang=js&"
import style0 from "./DigitCode.vue?vue&type=style&index=0&id=1b3293fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3293fb",
  null
  
)

export default component.exports